import { type CloudWatchMetric, type setupLogger } from '@zoopla/logger';

// We only pass through this value if there is one listing id; we omit if there
// are none or more than 1.
export const getTaxonomyListingId = (listingIds: string[]) => {
    return listingIds.length === 1 ? listingIds[0] : undefined;
};

export const logLeadMetric = (options: {
    logger: ReturnType<typeof setupLogger>;
    product:
        | 'agent_matcher'
        | 'agent_matcher_carousel'
        | 'agent_matcher_missed'
        | 'valuation_page';
    total: number;
}) => {
    const { logger, product, total } = options;

    // Log one unique lead
    logger.metric<CloudWatchMetric>(
        {
            value: 1,
            unit: 'Count',
            dimensions: {
                product,
            },
        },
        'unique valuation leads'
    );

    // Log the total leads
    logger.metric<CloudWatchMetric>(
        {
            value: total,
            unit: 'Count',
            dimensions: {
                product,
            },
        },
        'total valuation leads'
    );
};
